import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { ChartsService } from '../../../services/chartService/charts.service';
import { InfoGraphic } from '../../../dataModels/data-models';

@Component({
    moduleId: module.id,
    selector: 'info-graphic-number',
    templateUrl: 'infoGraphicNumber.component.html',
    styleUrls: ['infoGraphicNumber.component.css']
})

export class InfoGraphicNumber implements OnInit {
    labelData: number;
    @Input() infoGraphic: InfoGraphic;

    constructor(private chartsService: ChartsService) { }

    ngOnInit() {
        setTimeout(() => {
            this.chartsService.notifyMe.subscribe(() => this.calculate());

            this.calculate();
        }, 0);
    }

    calculate() {
        if (this.infoGraphic.countProperty) {
            this.labelData = this.chartsService.getCountOfValues(this.infoGraphic.data, this.infoGraphic.countProperty);
        }
        else if (this.infoGraphic.perValue) { // get average per some property
            let data = this.chartsService.groupByThenSumOrAvg(this.infoGraphic.data, this.infoGraphic.groupProperty,
                this.infoGraphic.value, this.infoGraphic.perValue);

            this.labelData = this.chartsService.sum(data, this.infoGraphic.value);
        }
        else if (this.infoGraphic.perTotalValue && this.infoGraphic.groupProperty) {
            // get average by divide property sum by property sum
            let data = this.chartsService.groupbyThenDivideSumBySum(this.infoGraphic.data,
                this.infoGraphic.groupProperty, this.infoGraphic.value, this.infoGraphic.perTotalValue);

            this.labelData = Math.round(this.chartsService.sum(data, this.infoGraphic.value));
        }
        else {
            this.labelData = this.chartsService.sum(this.infoGraphic.data, this.infoGraphic.value);
        }
    }
}




// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/components/charts/infoGraphicNumber/infoGraphicNumber.component.ts